import { environment } from '@/scripts/environments'

/**
 * Expose debug information to window object for easy console access.
 * WARNING: DO NOT EXPOSE SENSITIVE DATA LIKE API KEYS OR SECRETS
 *
 * Usage in browser console:
 * ```javascript
 * window.__DEBUG__
 * ```
 */
export function initializeDebugUtils(): void {
  window.__DEBUG__ = {
    env: {
      VITE_MODE: import.meta.env.MODE,
      NODE_ENV: process.env.NODE_ENV || 'N/A',
      API_BASE_URL: import.meta.env.VITE_BACKOFFICE_API_BASE_URL,
      environment,
    },
  }
}
